import React from "react";
import { RxExternalLink } from "react-icons/rx";
import { Link } from "react-router-dom";
import HoverToDisplayFullTitle from "../../../../reusableComponents/HoverToDisplayFullTitle";
import { useAuth } from "../../../../context/API_Client";
import { colorBrandObject } from "../../../../../constants/brandings";

const AllWebhookSchema = (
  deleteWebhookData,
  editWebhookData,
  operationPermissions
) => {
  const { isAuthorizedPermission } = useAuth();
  const WebhookRenderer = ({ data }) => {
    const webhookURl = data?.url;
    const webhookId = data?.id;
    return (
      <span style={{ display: "flex", marginLeft: "-12px" }}>
        <span
          style={{
            marginLeft: "-12px",
            maxWidth: "300px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <HoverToDisplayFullTitle title={webhookURl} len={24} />
        </span>
        <Link
          to={"/developers/webhooks/webhookDetail?webhookId=" + webhookId}
        >
          <RxExternalLink
            style={{
              width: "24px",
              cursor: "pointer",
              position: "absolute",
              right: "0",
              marginRight: "16px",
              color:`${colorBrandObject?.actionIconColor}`
            }}
          />
        </Link>
      </span>
    );
  };
  const schema = {
    metadata: {
      title: "Webhooks",
      minHeight: 600,
      position: "relative",
      showTitle: false,
      rowHeight: 65,
    },
    fields: [
      {
        name: "url",
        header: "URL",
        visible: true,
        type: "string",
        filtering: false,
        sortable: false,
        minWidth: 400,
        defaultFlex: 1,
        textAlign: "center",
        render: WebhookRenderer,
      },
      {
        name: "events",
        header: "Event Saved",
        visible: true,
        type: "string",
        defaultFlex: 1,
        filtering: false,
        minWidth: 200,
        defaultFlex: 1,
        textAlign: "center",
        render: ({ value }) => {
          let backgroundColor = "var(--global-purple-400, #E4E3FF)";
          let color = "var(--global-neutral-grey-1200, #1D1C20)";
          return (
            <span
              style={{
                marginLeft: "-10px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                color,
                fontFamily: "Poppins",
              }}
            >
              {value?.length}
            </span>
          );
        },
      },
      {
        name: "enabled",
        header: "Status",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        textAlign: "center",
        minWidth: 200,
        defaultFlex: 1,
        render: ({ value }) => {
          let backgroundColor;
          let color;

          if (value === true) {
            backgroundColor = "var(--comms-positive-sub, #D5FBD2)";
            color = "var(--comms-positive, #0B6A48)";
          } else if (value === false) {
            backgroundColor = "var(--comms-negative-sub, #FDE3D6)";
            color = "var(--comms-negative, #B9232F)";
          }
          return (
            <span
              style={{
                marginLeft: "-10px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                color,
                fontFamily: "Poppins",
              }}
            >
              {value === true ? "Active" : "Inactive"}
            </span>
          );
        },
      },
      {
        name: "id",
        header: "Actions",
        visible:
          isAuthorizedPermission(operationPermissions?.updateWebhook) ||
          isAuthorizedPermission(operationPermissions?.deleteWebhook),
        type: "string",
        defaultFlex: 1,
        filtering: false,
        minWidth: 200,
        defaultFlex: 1,
        textAlign: "center",
        display: "flex",
        sortable: false,
        render: ({ value }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "180px",
            }}
          >
            <div style={{ display: "flex", gap: "8px" }}>
              {isAuthorizedPermission(operationPermissions?.updateWebhook) && (
                <img
                  src="/assets/routingIcons/Edit-icon.svg"
                  className="edit-icon"
                  onClick={() => editWebhookData(value)}
                />
              )}
              {isAuthorizedPermission(operationPermissions?.deleteWebhook) && (
                <img
                  src="/assets/routingIcons/DeleteOutlinedIcon.svg"
                  className="delete-icon"
                  onClick={() => deleteWebhookData(value)}
                />
              )}
            </div>
          </div>
        ),
      },
    ],
  };
  return schema;
};

export default AllWebhookSchema;
